export const DEFAULT_COUNTRY_SHORT_CODE = 'SA';
export const DEFAULT_CURRENCY = 'SAR';

export const APPLE_PAY_SUPPORTED_METHODS = 'https://apple.com/apple-pay';
export const APPLE_PAYMENT_SESSION_URL =
  'https://apple-pay-gateway.apple.com/paymentservices/paymentSession';

export const APPLE_PAY_SUPPORTED_NETWORKS = [
  'visa',
  'mastercard',
  'amex',
  'mada',
];
export const APPLE_PAY_MERCHANT_CAPABILITIES = ['supports3DS'];

export const APPLE_PAY_LABEL = 'Dailymealz';
